/**
 * XEP-0424 retraction, send side. The read side is in `message.ts` — both
 * `<retract>` and the `<retracted>` tombstone arrive as ordinary messages.
 */
import xml, { type Element as XmlEl } from "@xmpp/xml"
import type { Jid } from "../../../jid"
import { NS_MESSAGE_RETRACT } from "../../../constants"
import { buildMessage } from "../build"

/**
 * `type` must match the original's — Costanza authorises a groupchat
 * retraction against the room's archive and everything else against the
 * sender's own, so a mismatch is refused as not-found.
 *
 * `targetId` goes in `<retract>`; `bounceId` is the stanza id a refusal echoes
 * back. They differ for a group (stanza-id vs origin-id), one value for a 1:1.
 */
export const buildRetractionMessage = (
  peer: Jid,
  targetId: string,
  bounceId: string
): XmlEl => buildMessage(bounceId, peer, buildRetract(targetId))

/** Bare, never in an XEP-0422 `<apply-to>` — ejabberd's MUC handler acts on
 * that form by deleting history out from under the tombstone. */
export const buildRetract = (targetId: string): XmlEl =>
  xml("retract", { xmlns: NS_MESSAGE_RETRACT, id: targetId })
